import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import type { UserRole } from "@/types/domain";

export function RoleGuard({
  role,
  children,
}: {
  role: UserRole;
  children: ReactNode;
}) {
  const { profile, loading } = useProfile();
  if (loading) return null;
  if (!profile) return <Navigate to="/login" replace />;
  if (profile.data.role !== role) {
    return (
      <Navigate
        to={profile.data.role === "parent" ? "/parent" : "/child"}
        replace
      />
    );
  }
  return <>{children}</>;
}
